import React, { useState, useEffect, useRef } from 'react';
import './App.css';
// import About from './components/About';
// import Articles from './components/Articles';
// import Research from './components/Research';
// import Landing from './components/Landing';

// Placeholder components for each section
// You can move these to separate files in a 'components' directory later

const Header = () => {
  return (
    <header>
      <nav className="container">
        <div className="logo">
          <a href="/#">
            <img src="/assets-new/logo.png" alt="Defsig Logo" id="firm-logo" />
            <span className="logo-text">Defsig</span>
          </a>
        </div>
        <ul>
          <li><a href="#about">About</a></li>
          <li><a href="#expertise">Focus Areas</a></li>
          <li><a href="#insights">Insights</a></li>
          <li><a href="#engage">Engage</a></li>
        </ul>
      </nav>
    </header>
  );
};

const Hero = () => {
  return (
    <section id="hero">
      <div className="container hero-content">
        <h1>Exploring the Frontiers of Information & Intelligence</h1>
        <p className="tagline">Dedicated to foundational research and open exploration in Information Theory, AI Alignment, and Semantics.</p>
        <a href="#insights" className="cta-button">View Insights</a>
      </div>
    </section>
  );
};

const AboutSection = () => {
  return (
    <section id="about" className="container content-section">
      <h2>About Defsig</h2>
      <p>Defsig is an independent innovation hub focused on advancing understanding at the intersection of information theory, artificial intelligence alignment, and semantic studies. Our approach is rooted in deep research, critical analysis, and the open exchange of ideas to foster innovation and explore new paradigms.</p>
    </section>
  );
};

const ExpertiseSection = () => {
  return (
    <section id="expertise" className="content-section alt-bg">
      <div className="container">
        <h2>Our Focus Areas</h2>
        <div className="expertise-grid">
          <div className="expertise-item">
            <img src="/assets-new/placeholder-info-theory.svg" alt="Information Theory Icon" className="expertise-icon" />
            <h3>Information Theory</h3>
            <p>Investigating the fundamental principles of information, its transmission, processing, and its role in complex systems.</p>
          </div>
          <div className="expertise-item">
            <img src="/assets-new/placeholder-ai-alignment.svg" alt="AI Alignment Icon" className="expertise-icon" />
            <h3>AI Alignment</h3>
            <p>Researching methodologies to ensure artificial intelligence systems operate congruently with human values and intentions.</p>
          </div>
          <div className="expertise-item">
            <img src="/assets-new/placeholder-semantics.svg" alt="Semantics Icon" className="expertise-icon" />
            <h3>Semantics</h3>
            <p>Advancing models for deep language understanding, knowledge representation, and the extraction of meaning from diverse data forms.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

const InsightsSection = () => {
  return (
    <section id="insights" className="container content-section">
      <h2>Insights & Publications</h2>
      <p>We share our findings, perspectives, and ongoing research through various channels. Explore our articles, papers, and discussions on the evolving landscape of AI and information science.
        <em>(Links to Medium, research repositories, and other publications will be featured here.)</em>
      </p>

      <article className="insight-preview">
        <h4>Stratification: The Dark Side of AI Acceleration</h4>
        <p className="insight-meta">[May 2025] - via Medium</p>
        <p>An analysis of how rapid AI advancements could inadvertently lead to new forms of societal stratification and digital divides, urging a cautious approach to AI acceleration.</p>
        <a href="https://medium.com/@alch3mist/stratification-the-dark-side-of-ai-acceleration-dcc21f5c0847" target="_blank" rel="noopener noreferrer">Read More on Medium &rarr;</a>
      </article>
      <article className="insight-preview">
        <h4>Digital Lifecycle Protection Models (DLPMs) in Blockchain Contexts</h4>
        <p className="insight-meta">[August 2024] - via Medium (Obscuro Labs)</p>
        <p>Exploring Digital Lifecycle Protection Models (DLPMs) and their application in blockchain environments to ensure the integrity and security of digital assets throughout their lifespan.</p>
        <a href="https://medium.com/obscuro-labs/digital-lifecycle-protection-models-dlpms-in-blockchain-contexts-d5b331aa28f0" target="_blank" rel="noopener noreferrer">Read More on Medium &rarr;</a>
      </article>
      <article className="insight-preview">
        <h4>mNFT: Trustless Semantic Bridging w/ Asymmetrical Key Analogy</h4>
        <p className="insight-meta">[June 2024] - via Medium</p>
        <p>Introducing mNFTs as a novel approach to trustless semantic bridging between disparate systems, explained through an analogy with asymmetrical key cryptography for enhanced interoperability.</p>
        <a href="https://medium.com/@alch3mist/mnft-trustless-semantic-bridging-w-asymmetrical-key-analogy-ff47c86fe52b" target="_blank" rel="noopener noreferrer">Read More on Medium &rarr;</a>
      </article>
    </section>
  );
};

const EngageSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Submitted:', formData);
    alert('Thank you for your message! (This is a demo - form not actually submitted)');
    setFormData({ name: '', email: '', message: '' }); // Reset form
  };

  return (
    <section id="engage" className="content-section alt-bg">
      <div className="container">
        <h2>Engage & Discuss</h2>
        <p>Defsig encourages dialogue with researchers, academics, and practitioners. We are open to exploring collaborative research opportunities and engaging in thoughtful discussions on topics within our focus areas.</p>
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message or Inquiry"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit" className="cta-button">Send Message</button>
        </form>
      </div>
    </section>
  );
};

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2024 Defsig. All rights reserved. | Advancing Understanding in Information & Intelligence.</p>
        <div className="social-links">
          <a href="/#">Medium</a> | <a href="/#">ResearchGate</a> | <a href="/#">Twitter</a>
        </div>
      </div>
    </footer>
  );
};

function App() {
  // Smooth scrolling and Scrollspy logic (can be extracted or use a library)
  const sectionsRef = useRef([]);
  const navLinksRef = useRef([]);

  useEffect(() => {
    // Collect all section elements
    const sectionElements = document.querySelectorAll('section[id]');
    sectionsRef.current = Array.from(sectionElements);

    // Collect all nav links
    const headerNavLinks = document.querySelectorAll('header nav ul li a');
    navLinksRef.current = Array.from(headerNavLinks);

    const handleScroll = () => {
      let currentSectionId = '';
      const headerElement = document.querySelector('header');
      if (!headerElement) return;

      const headerHeight = headerElement.offsetHeight;

      sectionsRef.current.forEach(section => {
        if (section) { // Ensure section exists
          const sectionTop = section.offsetTop - headerHeight - 50;
          const sectionBottom = sectionTop + section.offsetHeight;
          if (window.scrollY >= sectionTop && window.scrollY < sectionBottom) {
            currentSectionId = section.getAttribute('id');
          }
        }
      });

      navLinksRef.current.forEach(link => {
        if (link) { // Ensure link exists
          link.classList.remove('active');
          if (link.getAttribute('href') === `#${currentSectionId}`) {
            link.classList.add('active');
          }
        }
      });
    };

    const smoothScrollHandler = (e) => {
        const href = e.target.getAttribute('href');
        if (href && href.startsWith('#')) {
            e.preventDefault();
            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                const headerElement = document.querySelector('header');
                if (!headerElement) return;
                const headerOffset = headerElement.offsetHeight;
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        }
    };

    navLinksRef.current.forEach(link => {
        if (link) {
            link.addEventListener('click', smoothScrollHandler);
        }
    });

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call

    return () => {
      window.removeEventListener('scroll', handleScroll);
      navLinksRef.current.forEach(link => {
        if (link) {
            link.removeEventListener('click', smoothScrollHandler);
        }
      });
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <ExpertiseSection />
        <InsightsSection />
        <EngageSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
